import styles from "./InputWithSearch.module.css";
import { AiOutlineSearch } from "react-icons/ai";
import { useRef } from "react";

const InputWithSearch = ({ onSearchFn, ...restProps }) => {
    const inputRef = useRef(null);

  return (
    <div className={styles["input-with-search"]}>
      <input ref={inputRef} {...restProps} />
      <AiOutlineSearch
        title="Click here to search"
        onClick={() => onSearchFn && onSearchFn(inputRef.current.value)}
        style={onSearchFn && {'cursor': 'pointer'}}
        className={styles["search-icon"]}
      />
    </div>
  );
};

export default InputWithSearch;
